export const tooltipData = {
  'main_settings_block/1/1': {
    desc: 'flow.features.visitors.desc',
    preview: true,
  },
  'main_settings_block/1/2': {
    desc: 'flow.features.buyers.desc',
    preview: true,
  },
  'main_settings_block/1/2/7': {
    desc: 'flow.features.buyers.quantiry.desc',
  },
  'main_settings_block/1/3': {
    desc: 'flow.features.delivery.desc',
    preview: true,
  },
  'main_settings_block/1/4': {
    desc: 'flow.features.viewers.desc',
    preview: true,
  },
  'main_settings_block/1/5': {
    desc: 'flow.features.freezer.desc',
    preview: true,
  },
  'main_settings_block/1/25': {
    desc: 'flow.features.price_freeze.desc',
    preview: true,
  },
  'main_settings_block/1/26': {
    desc: 'flow.features.price_freeze.desc',
    preview: true,
  },
  'main_settings_block/2/36': {
    desc: 'flow.features.holidays.desc',
    preview: true,
  },
  'main_settings_block/2/16': {
    desc: 'flow.features.ok_bar.desc',
    preview: true,
  },

  'main_settings_block/2/17': {
    desc: 'flow.features.vk_bar.desc',
    preview: true,
  },
  'main_settings_block/2/23': {
    desc: 'flow.features.fb_bar.desc',
    preview: true,
  },
  'main_settings_block/2/21': {
    desc: 'flow.features.sale.desc',
    preview: true,
  },
  'main_settings_block/2/22': {
    desc: 'flow.features.friday.desc',
    preview: true,
  },
  'main_settings_block/2/24': {
    desc: 'flow.features.ny_bar.desc',
    preview: true,
  },
  'main_settings_block/2/28': {
    desc: 'flow.features.14_feb.desc',
    preview: true,
  },
  'main_settings_block/2/29': {
    desc: 'flow.features.23_feb.desc',
    preview: true,
  },
  'main_settings_block/2/30': {
    desc: 'flow.features.8_mar.desc',
    preview: true,
  },
  'main_settings_block/3/8': {
    desc: 'flow.features.cb-phone.desc',
    preview: true,
  },
  'main_settings_block/3/9': {
    desc: 'flow.features.cb-modal.desc',
    preview: true,
  },
  'main_settings_block/4/27': {
    desc: 'flow.features.your_contacts.desc',
    preview: true,
  },
  'main_settings_block/4/35': {
    desc: 'flow.features.your_contacts.desc',
    preview: true,
  },
};
